import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_URL } from '../consts';
import { TooltipData } from '../types';

const useFetchTooltipData = () => {
  const [data, setData] = useState<{ en: TooltipData; de: TooltipData } | null>(
    null
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const url = `${API_URL}/api/tooltips`;
      const response = await axios.get(url);
      setData(response.data[0]);
    } catch (err) {
      setError((err as any).toJSON());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!data) {
      fetchData();
    }
  }, [data, fetchData]);

  return { data, loading, error, refetch: fetchData, setData };
};

export default useFetchTooltipData;
